import * as z from "zod";
import { triggerOrderSchema } from "./common";

/**
 * Replaces a trigger's order if nobody changed it since `expectedVersion`;
 * otherwise nothing changes and the current order comes back.
 */
export const reorder = {
  name: "reorder" as const,
  input: z.object({
    triggerKind: z.string(),
    automationIds: z.array(z.string()),
    expectedVersion: z.number().int().nonnegative(),
  }),
  output: z.discriminatedUnion("ok", [
    z.object({ ok: z.literal(true), order: triggerOrderSchema }),
    z.object({ ok: z.literal(false), current: triggerOrderSchema }),
  ]),
};
